// extracted by mini-css-extract-plugin
module.exports = {"parent":"FooterDisclaimer-module--parent--2JCEd","svg_wrapper":"FooterDisclaimer-module--svg_wrapper--11urU","content_wrapper":"FooterDisclaimer-module--content_wrapper--1EzSR"};